import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ToolTip.less';

export const TOOLTIP_ICON_STYLE = {
    SOLID: '',
    LINE: 'icon-style-line'
};

export class ToolTip extends Component {
    static propTypes = {
        text: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        iconStyle: PropTypes.oneOf(Object.values(TOOLTIP_ICON_STYLE))
    };

    static defaultProps = {
        iconStyle: TOOLTIP_ICON_STYLE.SOLID
    };

    constructor() {
        super();
        this.state = {
            showToolTip: false
        };
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.closeTip);
        document.removeEventListener('keydown', this.closeTipOnEscape);
    }

    componentDidMount() {
        //This is JS Event listener. The onClick attached to the <a> tag is react event.
        document.addEventListener('click', this.closeTip);
        document.addEventListener('keydown', this.closeTipOnEscape);
    }

    closeTip = () => {
        if (this.state.showToolTip) {
            this.setState({
                showToolTip: false
            });
        }
    };

    openTip = () => {
        if (!this.state.showToolTip) {
            this.setState({
                showToolTip: true
            });
        }
    }

    closeTipOnEscape = event => {
        if (event.keyCode === 27) {
            this.closeTip();
        }
    };

    toggleTip = event => {
        event.preventDefault();
        //When we use a mix of JS event and react event, we have to do this.
        //This stops react event propagation
        event.stopPropagation();
        event.nativeEvent && event.nativeEvent.stopImmediatePropagation();

        this.setState({
            showToolTip: !this.state.showToolTip
        });
    };

    render() {
        const { text, id, iconStyle } = this.props;
        const isScreenReaderOnly = this.state.showToolTip ? '' : 'accessAid';

        const toolTipContent = (
            <div className={`tip-content-wrapper ${isScreenReaderOnly}`}>
                <span key="content2" className="tip-bubble tip-arrow-wrapper">
                    <span className="tip-arrow" />
                </span>
            </div>
        );

        const toolTip = (
            <div className={`tip-bubble tip-hint-wrapper ${isScreenReaderOnly}`}>
                <div className="tip-hint" role="tooltip" id={`${id}ToolTipContainer`}>
                    <span className="tip-text">{text}</span>
                </div>
            </div>
        );

        const showToolTipClass = this.state.showToolTip ? 'is-active' : '';

        return (
            <div className="ToolTip">
                <a
                    id={id}
                    href="#"
                    className={`tip-icon popup ${iconStyle} ${showToolTipClass}`}
                    tabIndex="0"
                    role="button"
                    aria-label={id}
                    aria-labelledby={`${id}ToolTipContainer`}
                    onClick={this.toggleTip}
                    onFocus={this.openTip}
                    onBlur={this.closeTip}
                    onMouseEnter={this.openTip}
                    onMouseLeave={this.closeTip}
                >
                    {toolTipContent}
                </a>
                {toolTip}
            </div>
        );
    }
}

export default ToolTip;
